import { extends as _extends, wrapRegExp as _wrapRegExp } from '../_virtual/_rollupPluginBabelHelpers.js';
import urlJoin from 'url-join';
import { isCID } from './isCID.esm.js';

var IPFS_SUBPATH = '/ipfs/';
var IPNS_SUBPATH = '/ipns/';

var networkRegex = /*#__PURE__*/_wrapRegExp(/(ipfs:\/|ipns:\/|ar:\/)?(\/)?(ipfs\/|ipns\/)?([\x2D\.0-9A-Z_a-z]+)(\/.*)?/, {
  protocol: 1,
  root: 2,
  subpath: 3,
  target: 4,
  subtarget: 5
});

var base64Regex = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/;
var dataURIRegex = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;

function _replaceGateway(uri, source, target) {
  if (uri.startsWith(source) && target) {
    try {
      var _uri = new URL(uri);

      _uri.hostname = new URL(target).hostname;
      return _uri.toString();
    } catch (_error) {
      return uri;
    }
  }

  return uri;
}

function resolveURI(uri, gateways, customGateway) {
  var _gateways3, _gateways4, _gateways5;

  // resolves uri based on its' protocol
  var isEncoded = base64Regex.test(uri);

  if (isEncoded || uri.startsWith('http')) {
    var _gateways, _gateways2;

    uri = _replaceGateway(uri, 'https://ipfs.io/', (_gateways = gateways) == null ? void 0 : _gateways.ipfs);
    uri = _replaceGateway(uri, 'https://arweave.net/', (_gateways2 = gateways) == null ? void 0 : _gateways2.arweave);
    return {
      uri: uri,
      isOnChain: isEncoded,
      isEncoded: isEncoded
    };
  } // customGateway option will be depreciated after 2 more version bump


  if (!((_gateways3 = gateways) != null && _gateways3.ipfs) && !!customGateway) {
    console.warn("'customGateway' option depreciated, please use 'gateways: {ipfs: YOUR_IPFS_GATEWAY }' instead");
    gateways = _extends({}, gateways, {
      ipfs: customGateway
    });
  }

  var ipfsGateway = ((_gateways4 = gateways) == null ? void 0 : _gateways4.ipfs) || 'https://ipfs.io';
  var arGateway = ((_gateways5 = gateways) == null ? void 0 : _gateways5.arweave) || 'https://arweave.net';
  var networkRegexResult = uri.match(networkRegex);

  var _ref = (networkRegexResult == null ? void 0 : networkRegexResult.groups) || {},
      protocol = _ref.protocol,
      subpath = _ref.subpath,
      target = _ref.target,
      _ref$subtarget = _ref.subtarget,
      subtarget = _ref$subtarget === void 0 ? '' : _ref$subtarget;

  if ((protocol === 'ipns:/' || subpath === 'ipns/') && target) {
    return {
      uri: urlJoin(ipfsGateway, IPNS_SUBPATH, target, subtarget),
      isOnChain: false,
      isEncoded: false
    };
  } else if (isCID(target)) {
    // Assume that it's a regular IPFS CID and not an IPNS key
    return {
      uri: urlJoin(ipfsGateway, IPFS_SUBPATH, target, subtarget),
      isOnChain: false,
      isEncoded: false
    };
  } else if (protocol === 'ar:/' && target) {
    return {
      uri: urlJoin(arGateway, target, subtarget || ''),
      isOnChain: false,
      isEncoded: false
    };
  } else {
    // we may want to throw error here
    return {
      uri: uri.replace(dataURIRegex, ''),
      isOnChain: true,
      isEncoded: false
    };
  }
}

export { resolveURI };
//# sourceMappingURL=resolveURI.esm.js.map
